(function () {
  const outingsEventsCalculationsApp = function () {
    const togglePanes = () => {
      $('[data-toggle=pane]')
        .on('click', function () {
          $(this).parent().find($(this).attr('data-target')).toggle();
        })
        .trigger('click');
    };

    $(document).on('turbolinks:load', () => {
      if (!$('body').hasClass('controller-outings-calculations')) return;

      togglePanes();
    });
  };

  if (typeof window !== 'undefined') {
    window.outingsEventsCalculationsApp = outingsEventsCalculationsApp();
  }
})();
